export default __webpack_public_path__ + "static/media/cancel-black.dabb15e4.svg";